export default {
  copy: 'Skopiuj do schowka',
};
